/**
 * Strip HTML from a given string.
 *
 * @param html - The input string potentially containing HTML.
 */
export const stripHTML = (html?: string): string => {
    if (html && typeof html === 'string') {
        const doc: Document = new DOMParser().parseFromString(html, 'text/html')

        return doc.body.textContent?.trim() || ''
    }

    return ''
}
